export const TIMER_MARK = '<p>@COUNTDOWN_TIMER@</p>'

export const CUSTOM_PROMOTION_MODAL = 'customPromotionModal'
